<modal
  [id]="id"
  [header]="(isEditMode() ? 'v2.orgSettings.apiKeys.editApiKeyTitle' : 'v2.orgSettings.apiKeys.createNew') | translate"
  [headerIcon]="isEditMode() ? editIcon : plusIcon"
  [widthClass]="'tw-w-11/12 lg:tw-w-[576px]'"
  [heightClass]="'tw-h-auto tw-max-h-[90vh]'"
  [showFooterDivider]="false"
  [closeButtonEnabled]="!isSubmitting() && !isLoadingApiToken()"
  [enableBackdropClose]="!isSubmitting() && !isLoadingApiToken()"
  [escapeToClose]="!isSubmitting() && !isLoadingApiToken()"
  (onCloseModal)="handleModalClose()"
>
  <div slot="body" class="tw-flex tw-flex-col -tw-mb-4">
    @if (isLoadingApiToken()) {
    <div class="tw-flex tw-min-h-[320px] tw-items-center tw-justify-center" role="status" aria-live="polite">
      <span class="tw-font-inter tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">{{ 'v2.orgSettings.apiKeys.loadingApiKey' | translate }}</span>
    </div>
    } @else {
    <basic-input
      [control]="form.controls.name"
      [label]="'v2.orgSettings.apiKeys.apiKeyName' | translate"
      [placeholder]="'v2.orgSettings.apiKeys.apiKeyName' | translate"
      [required]="true"
      [allowClearButton]="false"
    ></basic-input>

    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-6 tw-px-1 tw-mb-8">
      <label class="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-font-inter tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
        <input type="radio" class="tw-h-4 tw-w-4 tw-accent-blue-600" [formControl]="form.controls.access_type" value="full" />
        {{ 'v2.orgSettings.apiKeys.fullAccess' | translate }}
      </label>
      <label class="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-font-inter tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
        <input type="radio" class="tw-h-4 tw-w-4 tw-accent-blue-600" [formControl]="form.controls.access_type" value="limited" />
        {{ 'v2.orgSettings.apiKeys.limitedAccess' | translate }}
      </label>
    </div>

    @if (isLimitedAccess()) {
    <select-input
      class="tw-w-full"
      [control]="form.controls.event_id"
      [label]="'v2.orgSettings.apiKeys.event' | translate"
      [placeholder]="'v2.orgSettings.apiKeys.event' | translate"
      key="name"
      valueName="id"
      [values]="events"
      [minSelections]="1"
      [maxSelections]="1"
      [isDropdown]="true"
      [basicSelect]="true"
      [isBasicDropdownValue]="true"
      [enableSearch]="true"
      [isSingleSelect]="true"
      [clear]="true"
      [id]="'api_key_event_id'"
      [required]="true"
    ></select-input>
    }

    <div class="tw-flex tw-flex-col tw-gap-2 lg:tw-flex-row lg:tw-items-start lg:tw-gap-4">
      <p
        class="tw-shrink-0 tw-ps-1 tw-font-inter tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-300 lg:tw-mt-[5px] lg:tw-flex lg:tw-h-[58px] lg:tw-w-[205px] lg:tw-items-center"
      >
        {{ 'v2.orgSettings.apiKeys.permissionRegistration' | translate }}
      </p>
      <select-input
        class="tw-min-w-0 tw-flex-1"
        [control]="form.controls.registration_scopes"
        [label]="'v2.orgSettings.apiKeys.level' | translate"
        [placeholder]="'v2.orgSettings.apiKeys.level' | translate"
        key="name"
        [valueName]="'id'"
        [values]="registrationScopes"
        [minSelections]="1"
        [maxSelections]="registrationScopes.length"
        [isDropdown]="false"
        [basicSelect]="true"
        [enableSearch]="false"
        [isCountryField]="false"
        [isSingleSelect]="false"
        [clear]="false"
        [id]="'api_key_registration_scopes'"
        [required]="true"
      ></select-input>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-2 lg:tw-flex-row lg:tw-items-start lg:tw-gap-4">
      <p
        class="tw-shrink-0 tw-ps-1 tw-font-inter tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-300 lg:tw-mt-[5px] lg:tw-flex lg:tw-h-[58px] lg:tw-w-[205px] lg:tw-items-center"
      >
        {{ 'v2.orgSettings.apiKeys.permissionEventData' | translate }}
      </p>
      <select-input
        class="tw-min-w-0 tw-flex-1"
        [control]="form.controls.event_scopes"
        [label]="'v2.orgSettings.apiKeys.level' | translate"
        [placeholder]="'v2.orgSettings.apiKeys.level' | translate"
        key="name"
        [valueName]="'id'"
        [values]="eventScopes"
        [minSelections]="0"
        [maxSelections]="2"
        [isDropdown]="false"
        [basicSelect]="true"
        [enableSearch]="false"
        [isCountryField]="false"
        [isSingleSelect]="false"
        [clear]="false"
        [id]="'api_key_event_scopes'"
        [required]="false"
      ></select-input>
    </div>

    <date-picker
      [control]="form.controls.expires_at"
      [label]="'v2.orgSettings.apiKeys.expiryDate' | translate"
      [placeholder]="'v2.orgSettings.apiKeys.expiryDate' | translate"
      [isRequired]="true"
      [allowClearButton]="false"
      [minDate]="minDate"
      id="api-key-expiry-date"
    ></date-picker>
    }
  </div>

  <div slot="footer" class="tw-w-full tw-px-6 tw-pb-6">
    <button
      type="button"
      class="tw-w-full tw-rounded-lg tw-bg-blue-600 tw-py-2.5 tw-font-inter tw-text-sm tw-font-medium tw-text-white tw-transition-colors hover:tw-bg-blue-700 disabled:tw-pointer-events-none disabled:tw-bg-blue-300 lg:tw-py-3.5 lg:tw-text-base"
      [disabled]="isSaveDisabled()"
      [buttonSpinner]="isSubmitting() || isLoadingApiToken()"
      (click)="onSave()"
    >
      {{ 'v2.orgSettings.apiKeys.save' | translate }}
    </button>
  </div>
</modal>
